import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7e31bb4f&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=7e31bb4f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e31bb4f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e31bb4f')) {
      api.createRecord('7e31bb4f', component.options)
    } else {
      api.reload('7e31bb4f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7e31bb4f&scoped=true", function () {
      api.rerender('7e31bb4f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/promoter/index.vue"
export default component.exports